// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

import { applyMiddleware, createStore } from 'redux';
import { createRequestMiddleware } from 'redux-requests';
import thunkMiddleware from 'redux-thunk';

import rootReducer from '../reducers';

export default function configureStore (initialState) {
	const store = createStore(
		rootReducer,
		initialState,
		applyMiddleware(
			thunkMiddleware,
			createRequestMiddleware()
		)
	);

	if (module.hot) {
		// Enable Webpack hot module replacement for reducers
		module.hot.accept('../reducers', () => {
			const nextReducer = require('../reducers'); // eslint-disable-line global-require
			store.replaceReducer(nextReducer);
		});
	}

	return store;
}
